import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import SectionHeading from "./SectionHeading";

const FAQS = [
  {
    q: "What kind of company is SefKam Digital Solutions?",
    a: "We're a technology and innovation company. We provide software engineering, AI and automation, and digital transformation services, while developing our own AI-powered smart-home platform, SefKam Home.",
  },
  {
    q: "Is SefKam Home available to buy today?",
    a: "Not yet. SefKam Home is our product vision and is currently in development. It's positioned as Coming Soon — reach out and we'll keep you posted as it progresses.",
  },
  {
    q: "What does 'AI with purpose' mean in practice?",
    a: "We apply AI where it creates measurable value — such as automating repetitive workflows or building assistants grounded in your own knowledge — rather than adding AI for its own sake.",
  },
  {
    q: "Do you work with existing systems and legacy software?",
    a: "Yes. A large part of our work is modernizing legacy systems, integrating platforms, and building cloud-native foundations that let existing operations scale.",
  },
  {
    q: "How do we start a project with you?",
    a: "Send us a short note through the contact form describing your goal, timeline and context. We typically respond within 1–2 business days to explore how we can help.",
  },
];

export default function FAQ() {
  return (
    <section className="bg-[#F8FAFC] py-24 md:py-32" data-testid="faq-section">
      <div className="container-x grid gap-12 lg:grid-cols-[1fr_1.4fr]">
        <SectionHeading eyebrow="FAQs" title="Answers to common questions." max="max-w-sm" />
        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-slate-200" data-testid={`faq-${i}`}>
              <AccordionTrigger className="py-5 text-left font-display text-base font-medium text-[#07111F] hover:no-underline sm:text-lg">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm leading-relaxed text-slate-500">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
